import { ref } from "vue";
import { ApiError, api } from "@/api/client";

interface Pulso {
  ok: boolean;
  version: string;
  corriendo: number;
  ia?: { ok: boolean; detail: string; remedio?: string };
}

const pulso = ref<Pulso | null>(null);
const online = ref(true);
let started = false;

/**
 * El pulso del tablero: si el servidor contesta, cuántas corridas andan vivas y
 * cómo anda la credencial de la IA. Se sondea cada rato, y solo con la pestaña
 * a la vista.
 */
export function useStatus() {
  async function refresh(): Promise<void> {
    try {
      pulso.value = await api.system.pulso();
      online.value = true;
    } catch (error) {
      // «No has entrado» no es estar desconectado: es no haber entrado.
      const status = error instanceof ApiError ? error.status : 0;
      if (status !== 401 && status !== 403) online.value = false;
    }
  }

  if (!started) {
    started = true;
    void refresh();
    setInterval(() => {
      if (document.visibilityState === "visible") void refresh();
    }, 12_000);
  }

  return { pulso, online, refresh };
}
